import React from "react";
import type { TextColor } from "@/app/types/ui";

interface ParagraphBoldProps {
  children: React.ReactNode;
  color?: TextColor; // Pass the Tailwind text-color class you need
}

export const ParagraphBold = ({
  children,
  color = "text-black",
}: ParagraphBoldProps) => {
  return <p className={`font-bold text-base ${color}`}>{children}</p>;
};
